<template>
  <div class="wrap">
    <template v-if="!isNav">
      <Sticky>
        <Navbar :title="$t('page.openRecord')" />
      </Sticky>
    </template>
    <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
      :loading-text="$t('Hint.loading')">
      <div v-for="(item, index) in lists" :key="`item_${index}`" class="item_wrap app_card">
        <slot name="item" :item="item" :index="index">
          <div class="result">
            <div class="title">{{ $t("open.openTime") }}</div>
            <div class="value">
              {{ $format(item.opentime) }}
            </div>
          </div>
          <div class="order_num">
            <div class="title">{{ $t("popup.orderId") }}</div>
            <div class="value">{{ item.expect }}</div>
          </div>
          <div class="result">
            <div class="title">{{ $t("open.result") }}</div>
            <div class="ball_wrap" :class="item.type.indexOf('qq') > -1 ? 'ball_qq' : ''">
              <template v-if="item.type.indexOf('hl') > -1">
                <div class="ball_wraps">
                  <div class="ball_img" v-for="item, index in item.open.dwd" :key="index">
                    <img class="img" :src="require(`../../assets/icon/dice/${item}.png`)" alt="">
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="ball" v-for="(item, index) in item.open.dwd" :key="index">
                  {{ item }}
                </div>
              </template>
            </div>
          </div>
          <div class="result" v-if="item.type != 'bjsc' && item.type != 'xyft'">
            <div class="title">{{ $t("open.hz") }}</div>
            <div class="value">
              <template v-if="item.type.indexOf('qq') > -1">{{ item.open['hl-dwd'] }}</template>
              <template v-else>{{ item.open.zh.zh }}</template>
            </div>
          </div>
        </slot>
      </div>
    </List>
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import { Cell, List, Sticky } from "vant";
import { post } from "@/utils/newRequest";
export default {
  components: { Navbar, Cell, List, Sticky },
  props: {
    isNav: Boolean,
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      page: 0,
      loading: false,
      hasMore: true,
      lists: [],
      types: ''
    };
  },
  created() {
    const { type } = this.$route.query;
    this.types = type;
  },
  methods: {
    async getList(lower = false) {
      if (!lower) {
        this.page++;
      }
      try {
        const { lists, hasMorePages } = await post("/lottery/lists", {
          type: this.type || this.types,
          pagesize: 20,
          page: this.page,
        });
        const realList = lists.filter((item) => item.open.dwd);
        this.hasMore = hasMorePages;
        if (lower) {
          this.lists = [...realList]
        } else {
          this.lists = [...this.lists, ...realList];
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.page--;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@wrapPadding: calc(12rem / 16);
@comRadius: 10px;
@comBG: linear-gradient(#093958, #022c47);

.wrap {
  background: radial-gradient(circle at top right, rgba(49, 226, 165, .16), transparent 26%), radial-gradient(circle at left 25%, rgba(91, 140, 255, .12), transparent 22%), linear-gradient(180deg, #fbfcff, #f1f5fb);
  min-height: 100vh;
  overflow: hidden;
}

.item_wrap {
  // background: var(--btn_bg);
  margin: 12px;
  padding: 12px 20px;
  border-radius: 10px;

  >div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;

    &:nth-child(1) {
      margin-top: 0;
    }

    .title {
      // color: #999;
      color: var(--textColor);
      font-size: 14px;
    }

    .value {
      color: var(--textColor);
    }
  }

  .result {
    display: flex;
    gap: 10px;
    .value {
      display: flex;

      >img {
        width: 20px;
        height: 20px;
        margin-left: 12px;
      }
    }

    .ball_wrap {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      gap: 2px;
      .ball {
        border-radius: 50%;
        width: calc(26rem / 16);
        line-height: calc(26rem / 16);
        margin: 1px;
        text-align: center;
        background: var(--theme);
        color: #000;
        display: inline-block;
        background-image: url("../../assets/icon/game_ball.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .ball_wraps {
        display: flex;
        align-items: center;
        gap: calc(8rem / 16);

        .ball_img {
          .img {
            width: calc(30rem / 16);
            height: calc(30rem / 16);
            display: block;
          }
        }
      }
    }

    .ball_qq {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

      .qq_img {
        ._img {
          width: 30px;
          height: 30px;
          display: block;
        }
      }
    }
  }
}
</style>